import { ValidationStatus, WorkOrderStatus } from './validation-status.type';

// Base mappings for semantic status types
const statusMappings = {
  success: { icon: 'check_circle', cssClass: 'ck-success' },
  warning: { icon: 'warning', cssClass: 'ck-warn' },
  error: { icon: 'cancel', cssClass: 'ck-critical' },
  info: { icon: 'info', cssClass: 'ck-info' }
};

// Helper functions to get status mappings
const getStatusMapping = (status: ValidationStatus | WorkOrderStatus): typeof statusMappings.success => {
  switch (status) {
    case ValidationStatus.Valid:
    case WorkOrderStatus.Compliant:
      return statusMappings.success;
      
    case ValidationStatus.Warning:
    case WorkOrderStatus.Warning:
      return statusMappings.warning;
      
    case ValidationStatus.Invalid:
    case WorkOrderStatus.NonCompliant:
      return statusMappings.error;
      
    case ValidationStatus.Info:
      return statusMappings.info;
      
    default:
      return { icon: 'check_circle_outline', cssClass: 'ck-none' };
  }
};

export const getValidationIcon = (status: ValidationStatus | WorkOrderStatus): string => {
  return getStatusMapping(status).icon;
};

export const getValidationCssClass = (status: ValidationStatus | WorkOrderStatus): string => {
  return getStatusMapping(status).cssClass;
};
